import {MOON_50, MOON_200} from '@wandb/weave/common/css/color.styles';

export const HEADER_HEIGHT_PX = 44;
export const FOOTER_HEIGHT_PX = 44;
export const BORDER_COLOR = MOON_200;
export const SECONDARY_BACKGROUND_COLOR = MOON_50;
